import type { SupportedLocale } from './locale-from-pathname';

const ALLOWED: ReadonlySet<string> = new Set(['en', 'fi', 'sv']);

/**
 * Keeps `<html lang>` aligned with the active UI locale after hydration.
 * Some i18n stacks sync the attribute from `defaultLocale` when resolving messages.
 */
export function syncHtmlLangAttribute(locale: string): void {
  if (typeof document === 'undefined') return;
  const safe: SupportedLocale =
    ALLOWED.has(locale) ? (locale as SupportedLocale) : 'en';
  document.documentElement.setAttribute('lang', safe);
}
